module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-3-small-87695339addbd6c73b6fea2dfe5aea0f.png";